import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-drawer-workorder-actions',
  standalone: true,
  imports: [CommonModule, MatButtonModule, TranslateModule],
  templateUrl: './drawer-workorder-actions.component.html',
  styleUrls: ['./drawer-workorder-actions.component.scss'],
})
export class DrawerWorkorderActionsComponent implements OnInit {
  @Input() confirmButtonName!: string;
  @Input() confirmButtonIsEnable: boolean = true;
  @Output() clickCancelButtonEvent = new EventEmitter<boolean>();
  @Output() clickConfirmButtonEvent = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit() {}

  confirmButton() {
    this.clickConfirmButtonEvent.emit(true);
  }

  cancelButton() {
    this.clickCancelButtonEvent.emit(true);
  }
}
